import { useState } from "react";
import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export const companyUpdatesColumns = [
  {
    field: "date",
    headerName: "Date",
    flex: 1.2,
    sortComparator: (a, b) => {
    const parseDate = (str) => {
      if (!str || str === "—") return 0;
      return new Date(str).getTime();
    };
    return parseDate(a) - parseDate(b);
  },
  },
  {
    field: "rank",
    headerName: "Rank",
    flex: 1,
  },
  {
    field: "grade",
    headerName: "Grade",
    flex: 1,
    // Add the renderHeader function here
    renderHeader: (params) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <span>{params.colDef.headerName}</span>
        <Tooltip
          title="Company performance grade based on KPIs, revenue growth, and financial health. A = Excellent, B = Good, C = Average, D = Needs Improvement"
          arrow
          placement="top"
        >
          <IconButton size="small" sx={{ p: 0.25 }}>
            <HelpOutlineIcon sx={{ fontSize: 14, color: "#9CA3AF" }} />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  },

  {
    field: "reportingCurrency",
    headerName: "Reporting Currency",
    flex: 1,
    align: "left",
    headerAlign: "left",
  },
  {
    field: "carr",
    headerName: "CARR",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "annualKpi",
    headerName: "Annual KPI",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "netCashBalance",
    headerName: "NetCash Balance",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "monthlyBurn",
    headerName: "Monthly Burn",
    flex: 1,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "cashOut",
    headerName: "Cash Out",
    flex: 1,
  },
  /* {
    field: "updates",
    headerName: "Updates",
    flex: 1.2,
  }, */
  {
    field: "updates",
    headerName: "News",
    flex: 3,
    renderCell: (params) => <ExpandableUpdateCell value={params.value} />,
  },
];

const ExpandableUpdateCell = ({ value }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ display: "flex", alignItems: "start", width: "100%", py: 1 }}>
      <Typography
        variant="body2"
        sx={{
          whiteSpace: "normal",
          lineHeight: "1.5",
          // This creates the "one line" effect
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "unset" : 1, 
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          flex: 1,
        }}
      >
        {value}
      </Typography>
      <IconButton 
        size="small" 
        onClick={() => setExpanded(!expanded)} 
        sx={{ ml: 1, mt: -0.5 }}
      >
        {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
      </IconButton>
    </Box>
  );
};
